import React, { useEffect, useState } from 'react';
import { ErrorOutline } from '@mui/icons-material';
import { toast } from 'react-toastify';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import { InputText } from 'primereact/inputtext';
import {
  StyledContainerFooterSideBar,
  StyledContainerItems,
  StyledTitleSideBar
} from '../../../components/commons/SideBarComponents/sideBarComponentsStyles';
import Strings from '../../../i18n';
import { SideBarSimpleMethodItem } from '../../../components/commons/SideBarComponents/SimpleMethodItem/sideBarSimpleMethodButtonItem';
import { useSendProFlagMutation } from '../../../services/device/deviceService';
import { colors } from '../../../constants/colors';

interface SetProFlagSideBarProps {
  devicesIds: string[];
  reloadTable: () => void;
  setOpenRightSideBar: (open: boolean) => void;
  clearSelectedItems: () => void;
}
export const SetProFlagSideBar = ({
  devicesIds,
  reloadTable,
  setOpenRightSideBar,
  clearSelectedItems
}: SetProFlagSideBarProps) => {
  const [date, setDate] = useState(new Date());
  const challengeString = 'SET PROFLAG';
  const [challengeInput, setChallengeInput] = useState('');
  const [method, setMethod] = useState<boolean>(false);
  const [clickConfirm, setClickConfirm] = useState(false);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [sendProFlagCommand, { isLoading, isSuccess, isError, error }] =
    useSendProFlagMutation();

  useEffect(() => {
    if (isError) {
      toast.error(`${(error as { data: { message: string } }).data.message}`);
    }
  }, [isError]);

  const handleOpenDialog = (value: boolean) => {
    setMethod(value);
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
    setChallengeInput('');
  };

  const sendProFlag = () => {
    sendProFlagCommand({
      deviceIds: devicesIds,
      isPro: method
    });
  };

  useEffect(() => {
    if (isSuccess) {
      reloadTable();
      setOpenRightSideBar(false);
      setMethod(false);
      clearSelectedItems();
      toast.success(Strings.serverAccess.devices.proFlag.successSendProFlag);
      handleClose();
    }
  }, [isSuccess]);

  return (
    <>
      <StyledContainerItems>
        <StyledTitleSideBar>
          {Strings.serverAccess.devices.proFlag.setProFlag}
        </StyledTitleSideBar>
        <SideBarSimpleMethodItem
          name={Strings.serverAccess.devices.proFlag.proFlagTurnOn}
          action={() => {
            handleOpenDialog(true);
          }}
          successAction={false}
          textSuccess="success"
        />
        <SideBarSimpleMethodItem
          name={Strings.serverAccess.devices.proFlag.proFlagTurnOff}
          action={() => {
            handleOpenDialog(false);
          }}
          successAction={false}
          textSuccess="success"
        />
      </StyledContainerItems>
      <StyledContainerFooterSideBar>
        <button
          type="button"
          className="btn-cancel"
          onClick={() => {
            setOpenRightSideBar(false);
          }}
        >
          {Strings.common.cancel}
        </button>
      </StyledContainerFooterSideBar>

      <Dialog
        sx={{
          '& .MuiDialog-paper': {
            width: '80%',
            maxHeight: 435
          }
        }}
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          className="text-center"
          sx={{
            fontWeight: 'bold',
            fontSize: '2rem'
          }}
        >
          <p className="mb-0">
            <ErrorOutline
              sx={{ color: colors.yellowLight, fontSize: '6rem' }}
            />
          </p>
          {Strings.serverAccess.devices.proFlag.areYouSure}
        </DialogTitle>
        <DialogContent>
          <p className="text-center">
            {method
              ? Strings.serverAccess.devices.proFlag.confirmThisChallengeTitleOn
              : Strings.serverAccess.devices.proFlag
                  .confirmThisChallengeTitleOff}
          </p>
          <DialogContentText
            id="alert-dialog-description"
            className="text-center"
          >
            <span className="fw-bold">
              {Strings.serverAccess.devices.proFlag.confirmThisChallengeText}
            </span>
          </DialogContentText>
          <DialogContentText id="alert-dialog-description">
            <InputText
              value={challengeInput}
              size="small"
              className="w-100"
              onChange={(e) => setChallengeInput(e.target.value)}
            />
          </DialogContentText>
          {clickConfirm && challengeInput !== challengeString && (
            <DialogContentText id="alert-dialog-description">
              {
                Strings.serverAccess.devices.proFlag
                  .confirmThisChallengeTextError
              }
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              sendProFlag();
            }}
            color="success"
            variant="contained"
            disabled={challengeInput !== challengeString}
          >
            {challengeInput !== challengeString
              ? Strings.serverAccess.devices.proFlag
                  .confirmThisChallengeTextError
              : Strings.common.ok}
          </Button>
          <Button
            onClick={() => handleClose()}
            color="error"
            variant="contained"
          >
            {Strings.common.cancel}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
